<template>
  <section style="position: relative">
    <div v-if="currentStage < 2" class="d-flex flex-column align-center justify-center"
         style="position: fixed; width: 100%; z-index: 888; height: 100%; ">
      <div style="background-color: rgb(33, 33, 33); opacity: 0.26; width: 100%; height: 100%; ">

      </div>
      <v-card class="d-flex flex-column align-center justify-center" style="position: fixed; z-index: 889;  ">
        <v-card-text class="section-header__title main-color__important pb-0">
          Идёт этап согласования ОКЦП Центрами ответственности
        </v-card-text>
      </v-card>
    </div>

    <div class="d-flex flex-row justify-space-between align-center mb-3">
      <h1 class="section-header__title mb-0">
        Согласование общих объемов КЦП на 2025/26 учебный год (субъекты РФ)
      </h1>
      <div class="d-flex flex-row align-center">
        <v-btn
            v-if="!isBlockedRegion"
            class="white__v-btn"
            :loading="blocking"
            @click="blockStage"
        >
          Заблокировать Ввод
        </v-btn>
      </div>
    </div>
    <v-dialog v-model="showMessagesForBlock" scrollable>
      <v-card>
        <v-card-text class="py-10">
          <p class="mb-0" v-for="message in messagesForBlock" :key="message">{{ message }}</p>
        </v-card-text>
      </v-card>
    </v-dialog>
    <wrapper-collapse
        custom-class="orange-border-left"
        title="Правила корректировки общих объемов КЦП на 2025/26 учебный год (далее – ОКЦП) субъектами РФ"
        initial-open
    >
      <p class=" mb-2 mt-2 ">В целях сохранения баланса распределения контрольных цифр приема на обучение по
        образовательным программам
        высшего образования, а также по научным специальностям и (или) группам научных специальностей для обучения по
        программам подготовки научных и научно-педагогических кадров в аспирантуре (адъюнктуре) допускается
        корректировка проекта объема контрольных цифр приема в пределах 10 процентов по соответствующей НП(С) и (или)
        УГНС</p>
    </wrapper-collapse>
    <wrapper-collapse
        v-if="isBlockedRegion && !hasConfirmFile"
        title="Просмотр и подписание введенных данных"
        initial-open
        active-class="border-active-content"
    >
      <div class="file">
        <div class="mt-3">
        <v-btn
            class="white__v-btn"
            :loading="downloadingPrint"
            @click="downloadPrint('PrintStage2', 'downloadingPrint','Просмотр введенных данных.pdf','application/pdf', `?regionId=${userId}`)"
        >
          Просмотр документа с введенными данными
        </v-btn>
        <v-autocomplete
            v-model="chosenCertificate"
            :items="certificatesList"
            label="Выберите сертификат, которым будет произведена подпись данных"
            no-data-text="Нет доступных сертификатов"
            dense
            class="mt-2"
            clearable
            outlined
        ></v-autocomplete>
        <v-btn class="blue__v-btn" :disabled="!chosenCertificate" :loading="signingFile" @click="signFile('PrintStage2', 'downloadingPrint', `?regionId=${userId}`)">
          Подписать
        </v-btn>
        </div>
      </div>
    </wrapper-collapse>
    <wrapper-collapse
        title="Загружаемые файлы"
        initial-open
        active-class="border-active-content"
        v-if="isBlockedRegion || getFakeUser"
    >
      <file-container
          :num-stage="2" :current-stage="currentStage" :disabled="currentStage !== 2"
          ref="fileContainerStage2Ref" :files-config="filesConfig"  :regionID="regionID"
      />
    </wrapper-collapse>
    <wrapper-preview-category>
      <div class="d-flex flex-row align-center justify-space-between">

        <div class="d-flex ugs-name flex-row align-center">
          <p class="mb-0 ">
            {{ selectedRegion.name }}
          </p>
        </div>

        <div class="filters">
          <span class="mx-1 usl-name" :class="{'usl-name__chosen': usl.id === 1}"
                @click="choseUsl({name: 'Бакалавриат', id: 1})">Бакалавриат</span>
          <span class="mx-1 usl-name" :class="{'usl-name__chosen': usl.id === 2}"
                @click="choseUsl({name: 'Специалитет', id: 2})">Специалитет</span>
          <span class="ml-2 usl-name" :class="{'usl-name__chosen': usl.id === 3}"
                @click="choseUsl({name: 'Магистратура', id: 3})">Магистратура</span>
        </div>
        <div class="filters">
          Формы обучения:
          <span class="mx-1 usl-name" :class="{'usl-name__chosen': fo.id === 1}"
                @click="choseFo({name: 'очно', id: 1})">очно</span>
          <span class="mx-1 usl-name" :class="{'usl-name__chosen': fo.id === 2}"
                @click="choseFo({name: 'очно-заочно', id: 2})">очно-заочно</span>
          <span class="ml-1 usl-name" :class="{'usl-name__chosen': fo.id === 3}"
                @click="choseFo({name: 'заочно', id: 3})">заочно</span>
        </div>
        <v-btn class="white__v-btn" :loading="downloadingPrintExcel"
               @click="downloadPrint('ExcelStage2', downloadingPrintExcel,'Экспорт данных.xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',`?regionId=${userId}`)"
        >
          Выгрузка в Excel
        </v-btn>
      </div>
      <v-divider class="my-3"/>
      <GridTable
          :data-rows="showingData"
          :headers="headers.massive"
          :headers-for-rows="headersForRows"
          :loading-data="loadingData"
          :num-cols="headers.countCells"
          loader-color="#78909C"
      >
        <template #pv="{ row, cell }">
          <div>
            <!--            :class="{'svg-table-text': true}"-->
            <!--            @click="cellClick(row, 1, row.pv)">-->
            {{ cell.template(row) }}
          </div>
        </template>
        <template #pp="{ row , cell}">
          <div>
            <!--            :class="{'svg-table-text': true}"-->
            <!--            @click="cellClick(row, 2, row.pp)">-->
            {{ cell.template(row) }}
          </div>
        </template>
        <template #dj="{ row, cell }">
          <div>
            <!--            :class="{'svg-table-text': true}"-->
            <!--            @click="cellClick(row, 3,row.dj)">-->
            {{ cell.template(row) }}
          </div>
        </template>
        <template #startValue="{ row, cell }">
          <div>
            <!--            @click="cellClick(row, 4, row.startValue)"-->
            <!--            :class="{'svg-table-text': true}">-->
            {{ cell.template(row) }}
          </div>
        </template>
        <template #stage2Value="{row}">
          <table-cell-co123-menu
              name-changed-field="stage2Value"
              :disabled="isBlockedRegion"
              :id="row.id"
              :row="row"
              :stage-number="2"
              :value="row.stage2Value"
              @update="changedValue($event)"
          >
            <template #header-title>
              Предложение региона
            </template>
          </table-cell-co123-menu>
        </template>
      </GridTable>
    </wrapper-preview-category>
    <div
        v-if="dialog" :class="dialog ? 'v-overlay--active' : ''" aria-modal="true"
        role="dialog" style="z-index: 2400; margin: 0; align-items: center;
      justify-content: center; border-radius: inherit;display: flex;left: 0;
      pointer-events: none;position: fixed;top: 0;bottom: 0;right: 0; direction: ltr;"
    >
      <div
          @click="dialog = false" style="pointer-events: auto; background: #000000; border-radius: inherit;bottom: 0;
         left: 0;opacity: .32;position: fixed;right: 0;top: 0">
      </div>
      <div style="width: 1160px; max-height: 915px; margin: 24px; display: flex; flex-direction: column;
       outline: none;position: absolute;pointer-events: auto;contain: layout;"
      >
        <v-card
            style="background-attachment: scroll; background-size: auto; display: flex; flex-direction: column; overflow-x: hidden; overflow-y: auto">
          <DialogSvg
              :key="key"
              :columnNum="columnNum"
              :kcpGroupId="kcpGroupId"
              :regionId="regionId"
              :regionName="regionName"
              :sprKcpGroupId="sprKcpGroupId"
              :sprKcpGroupName="sprKcpGroupName"
              :uslName="uslName"
              :foName="foName"
              :pb="pb"
              :row="row"
              style="display: flex"
          />
        </v-card>
      </div>
    </div>
  </section>
</template>

<script>
import WrapperPreviewCategory from "@/components/wrappers/WrapperPreviewCategory";
import WrapperCollapse from "@/components/wrappers/WrapperCollapse";
import {mapServerData} from "@/helpers/regionsMappers";
import {mapActions, mapGetters} from "vuex";
import GridTable from "@/components/GridTable/GridTable";
import stageTwo from "@/helpers/tableConfigs/stageTwo";
import TableCellCo123Menu from "@/components/Menus/tableCellCo123Menu";
import FileContainer from "@/containers/FileContainer";
import {svgOpenFunctions} from "@/mixins/svgOpenFunctions";
import {setCryptoProFunctions} from "@/mixins/cryptoProFunctions";
import DialogSvg from "@/components/Dialogs/DialogSvg";
import {setFileFunctions} from "@/mixins/fileFucntions";
import UserController from "@/controllers/UserController";
import RegionStageController from "@/controllers/OKCP/RegionStageController";

export default {
  name: "Stage2",
  components: {DialogSvg, FileContainer, TableCellCo123Menu, GridTable, WrapperCollapse, WrapperPreviewCategory},
  mixins: [svgOpenFunctions, setFileFunctions, setCryptoProFunctions],
  data() {
    return {
      usl: {name: 'Бакалавриат', id: 1},
      fo: {name: 'Очно', id: 1},
      serverData: [],
      chosenData: [],
      loadingData: false,
      messagesForBlock: [],
      defaultFilesConfig: [
        {
          name: 'Файл подтверждения введенных данных',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'CONFIRMED_FILE_STAGE_TWO',
          canUpload: false
        },
        // {
        //   name: 'Расчетный файл',
        //   types: ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
        //   typesForChose: ['.xlsx', '.xls'],
        //   id: null,
        //   fileType: 'CALCULATED_FILE_STAGE_TWO'
        // },
        {
          name: 'Пояснительная записка',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'EXPLANATORY_FILE_STAGE_TWO',
          canUpload: true
        }, {
          name: 'Письмо для Минобрнауки',
          types: ['application/pdf'],
          typesForChose: ['application/pdf'],
          id: null,
          fileType: 'LETTER_FILE_STAGE_TWO',
          canUpload: true
        },
      ],
      showMessagesForBlock: false,
      blocking: false,
      headers: {
        massive: [],
        headersForRows: [],
        countCells: 1
      },
    }
  },
  computed: {
    ...mapGetters('keycloak', {isAdmin: 'isAdmin', getAuthData: 'getAuthData', getFakeUser: 'getFakeUser'}),
    ...mapGetters('checkFilled', {getBlockStageTwo: 'getBlockStageTwo', currentStage: 'currentStage', getFilesList: 'getFilesList'}),
    isBlockedRegion() {
      return this.getBlockStageTwo
    },
    regionID() {
      return this.getAuthData?.regionID
    },
    hasConfirmFile() {
      const cffile = this.getFilesList.filter(item => item.fileType === 'CONFIRMED_FILE_STAGE_TWO')[0];
      return cffile !== undefined && cffile !== null && cffile.id;

    },
    selectedRegion() {
      return {name: this.getAuthData?.given_name, id: this.getAuthData?.regionID}
    },
    headersForRows() {
      return this.headers.rowsMassive
    },
    showingData() {
      return this.chosenData?.data ?? []
    },
    filesConfig() {
      const agreementFile = [5, 6, 11, 17, 18, 28, 30, 33, 36, 42, 47, 56, 65, 66, 81, 89, 90, 93].includes(this.selectedRegion?.id || this.getFakeUser?.id) ? {
        name: 'Согласование проекта КЦП с Министерством Российской Федерации по развитию Дальнего Востока и Арктики',
        types: ['application/pdf'],
        typesForChose: ['application/pdf'],
        id: null,
        fileType: 'AGREEMENT_FILE_STAGE_TWO_VOSTOK',
        canUpload: true
      } : null;
      const agreementFile2 = [16, 20, 24, 29, 69, 71, 85].includes(this.selectedRegion?.id || this.getFakeUser?.id) ? {
        name: 'Согласование проекта КЦП с Министерством экономического развития Российской Федерации',
        types: ['application/pdf'],
        typesForChose: ['application/pdf'],
        id: null,
        fileType: 'AGREEMENT_FILE_STAGE_TWO_ECONOM',
        canUpload: true
      } : null;
      const result = [...this.defaultFilesConfig];
      if (agreementFile)
        result.push(agreementFile)
      if (agreementFile2)
        result.push(agreementFile2)
      return result;
    }
  },
  activated() {
    this.getServerData();
    if (this.isBlockedRegion) {
      this.checkSystem()
    }
  },
  created() {
    this.headers = stageTwo.call(this);
    this.getServerData();
    if (this.isBlockedRegion) {
      this.checkSystem()
    }
  },
  methods: {
    ...mapActions('checkFilled', {changeBlockInfo: 'changeBlockInfo', getBlockAllows: 'getBlockAllows'}),
    async blockStage() {
      this.blocking = true;
      try {
        const messagesBlock = await this.getBlockAllows(2);
        if (messagesBlock?.length === 0 || messagesBlock === undefined) {
          const res = await UserController.setBlock('region', 2)
          await this.changeBlockInfo(res);
          this.checkSystem()
        } else {
          this.messagesForBlock = messagesBlock;
          this.showMessagesForBlock = true;
        }
        this.blocking = false
      } catch (e) {
        this.blocking = false
      }
    },
    initFiles() {
      this.$refs.fileContainerStage2Ref.initFiles()
    },
    async getServerData() {
      this.serverData = [];
      this.chosenData = [];
      try {
        this.loadingData = true;
        const searchDownloadedElement = this.returnDownloadedElement()
        if (searchDownloadedElement)
          this.chosenData = searchDownloadedElement;
        else {
          const res = await RegionStageController.getDataStage(this.usl.id, this.fo.id);
          const firstElement = res.length > 0 ? res[0] : null;
          this.serverData.push(mapServerData(firstElement, res, this.$data));
          this.chosenData = this.returnDownloadedElement();
        }
        this.loadingData = false;
      } catch (e) {
        this.serverData.push(mapServerData(null, [], this.$data));
        await this.initFiles()
        this.chosenData = this.returnDownloadedElement();
        this.loadingData = false;
      }
    },
    changedValue(e) {
      const searchDownloadedElement = this.returnDownloadedElement();
      if (searchDownloadedElement) {
        const searchedRow = searchDownloadedElement.data.find(el => el.id === e.row?.id);
        if (searchedRow)
          searchedRow[e.dataField] = e.value;
        const searchedChosenData = this.chosenData.data.find(el => el.id === e.row?.id);
        if (searchedChosenData)
          searchedChosenData[e.dataField] = e.value;
      }
    },
    cellClick(row, columnNum, dash) {
      if (Number.isNaN(Number(dash)))
        return;
      // eslint-disable-next-line no-unreachable
      // console.log(row, dash)
      /*kcpGroupId, regionId, regionName, sprKcpGroupId, sprKcpGroupName,*/
      this.key = Math.random();
      this.columnNum = null;
      this.kcpGroupId = null;
      this.regionId = null;
      this.regionName = null;
      this.sprKcpGroupId = null;
      this.sprKcpGroupName = null;

      this.columnNum = columnNum;
      this.kcpGroupId = row.kcpGroup.id;
      this.regionId = row.region?.id;
      this.regionName = row.region?.name;
      this.uslName = row.kcpGroup?.usl?.name;
      this.foName = row.fo?.name;
      this.sprKcpGroupId = row.kcpGroup.id;
      this.sprKcpGroupName = row.kcpGroup.code + ' ' + row.kcpGroup.name;
      this.row = row;
      this.pb = row.dj === null && row.pp === null && row.pv === null;

      if (dash != null) {
        this.dialog = true;
      }
    },

    returnDownloadedElement() {
      return this.serverData.find(el => el.uslId === this.usl.id && el.foId === this.fo.id);
    },
    choseUsl(usl) {
      this.usl = usl;
      this.getServerData()
    },
    choseFo(fo) {
      this.fo = fo;
      this.getServerData()
    },
  }
}
</script>

<style scoped>

</style>